import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import {
  Grid,
  TextField,
  Button,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Checkbox,
  Container,
  Grid2

} from "@mui/material";

import { mockUnidadesAtendimento, mockComoConheceuUBC, mockSociedadesUBC } from '../mock';
import limiteTamanhoCampos from '../limiteCampos';

const unidadesAtendimento = await mockUnidadesAtendimento();
const sociedades = mockSociedadesUBC();

const FormularioFiliacaoUBC = forwardRef((props, ref) => {

  const listaComoConheceuUBC = mockComoConheceuUBC();

  const [filiadoVazio, setFiliadoVazio] = useState(false);
  const [naoFiliadoVazio, setaoFiliadoVazio] = useState(false);


  const [formData, setFormData] = useState(
    {
      compositorAutorAutorais: props?.formData?.compositorAutorAutorais || false,
      territorioAdmAutorais: props?.formData?.territorioAdmAutorais || 2136,
      territorioAdmAutoraisOutro: props?.formData?.territorioAdmAutoraisOutro || "",

      interpreteConexao: props?.formData?.interpreteConexao || false,
      musicoConexao: props?.formData?.musicoConexao || false,
      produtorFonograficoConexao: props?.formData?.produtorFonograficoConexao || false,
      territorioAdmConexao: props?.formData?.territorioAdmConexao || 2136,
      territorioAdmConexaoOutro: props?.formData?.territorioAdmConexaoOutro || "",

      compositorAutorNaoFiliacao: props?.formData?.compositorAutorNaoFiliacao || false,
      interpreteNaoFiliacao: props?.formData?.interpreteNaoFiliacao || false,
      musicoNaoFiliacao: props?.formData?.musicoNaoFiliacao || false,
      produtorFonograficoNaoFiliacao: props?.formData?.produtorFonograficoNaoFiliacao || false,

      compositorAutorFiliado: props?.formData?.compositorAutorFiliado || false,
      InterpreteFiliado: props?.formData?.InterpreteFiliado || false,
      musicoFiliado: props?.formData?.musicoFiliado || false,
      produtorFonograficoFiliado: props?.formData?.produtorFonograficoFiliado || false,
      sociedadeCompositorAutor: props?.formData?.sociedadeCompositorAutor || "",
      sociedadeInterprete: props?.formData?.sociedadeInterprete || "",
      sociedadeMusico: props?.formData?.sociedadeMusico || "",
      sociedadeProdutor: props?.formData?.sociedadeProdutor || "",

      tipoFiliacao: props?.formData?.tipoFiliacao || "",

      unidadeAtendimento: props?.formData?.unidadeAtendimento || "",
      contatoAtendimento: props?.formData?.contatoAtendimento || "",
      comoConheceuUBC: props?.formData?.comoConheceuUBC || "",
      quemIndicouUBC: props?.formData?.quemIndicouUBC || "",
      impressao: props?.formData?.impressao || false,
    });

  const [validacao, setValidacao] = useState({
    sociedadeCompositorAutor: false,
    sociedadeInterprete: false,
    sociedadeMusico: false,
    sociedadeProdutor: false,
    unidadeAtendimento: false,
    tipoFiliacao: false,

    naturezaFiliacao: false,
    compositor: true,
    interprete: true,
    musico: true,
    produtor: true,

    territorioConexao: true,
    territorioAutoral: true,

    territorioConexaoOutros: true,
    territorioAutoralOutros: true,

  });

  useEffect(() => {
    validaForm();
    props.onChildDataChange(formData);
    setFiliadoVazio(blocoFiliadoVazio());
    setaoFiliadoVazio(blocoNaoFiliacaoVazio());
  }, [formData]);

  useEffect(() => {
    validaForm();
  }, []);

  const blocoFiliadoVazio = () => {
    return formData['compositorAutorFiliado'] == false
      && formData['InterpreteFiliado'] == false
      && formData['musicoFiliado'] == false
      && formData['produtorFonograficoFiliado'] == false
      && formData['sociedadeCompositorAutor'] == ''
      && formData['sociedadeInterprete'] == ''
      && formData['sociedadeMusico'] == ''
      && formData['sociedadeProdutor'] == '';
  }

  const blocoNaoFiliacaoVazio = () => {
    return formData['compositorAutorNaoFiliacao'] == false
      && formData['interpreteNaoFiliacao'] == false
      && formData['musicoNaoFiliacao'] == false
      && formData['produtorFonograficoNaoFiliacao'] == false;
  }

  const validaForm = () => {

    const validaSociedadeCompositorAutor = !(formData.compositorAutorFiliado && formData.sociedadeCompositorAutor == '');
    const validasociedadeInterprete = !(formData.InterpreteFiliado && formData.sociedadeInterprete == '');
    const validasociedadeMusico = !(formData.musicoFiliado && formData.sociedadeMusico == '');
    const validasociedadeProdutor = !(formData.produtorFonograficoFiliado && formData.sociedadeProdutor == '');
    const validaSeNaturezaFiliacaoSelecionada = (formData.compositorAutorAutorais || formData.interpreteConexao || formData.musicoConexao || formData.produtorFonograficoConexao)

    const validaCompositor = !formData.compositorAutorAutorais || (formData.compositorAutorAutorais && (formData.compositorAutorFiliado || formData.compositorAutorNaoFiliacao));
    const validaInterprete = !formData.interpreteConexao || (formData.interpreteConexao && (formData.InterpreteFiliado || formData.interpreteNaoFiliacao));
    const validaMusico = !formData.musicoConexao || (formData.musicoConexao && (formData.musicoFiliado || formData.musicoNaoFiliacao));
    const validaProdutor = !formData.produtorFonograficoConexao || (formData.produtorFonograficoConexao && (formData.produtorFonograficoFiliado || formData.produtorFonograficoNaoFiliacao));

    const validaTerritorioConexao = !(formData.compositorAutorAutorais && !formData.territorioAdmAutorais);
    const validaTerritorioAutoral = !((formData.produtorFonograficoConexao || formData.interpreteConexao || formData.musicoConexao) && !formData.territorioAdmConexao);

    const validaterritorioConexaoOutros = !(formData.compositorAutorAutorais && formData.territorioAdmAutorais == "Outros" && !formData.territorioAdmAutoraisOutro);
    const validaTerritorioAutoralOutros = !(
      (formData.produtorFonograficoConexao || formData.interpreteConexao || formData.musicoConexao)
      && formData.territorioAdmConexao == "Outros" && !formData.territorioAdmConexaoOutro
    );

    setValidacao((prevState) => {
      const updatedState = {
        ...prevState
      };

      updatedState.sociedadeCompositorAutor = validaSociedadeCompositorAutor;
      updatedState.sociedadeInterprete = validasociedadeInterprete;
      updatedState.sociedadeMusico = validasociedadeMusico;
      updatedState.sociedadeProdutor = validasociedadeProdutor;
      updatedState.naturezaFiliacao = validaSeNaturezaFiliacaoSelecionada;
      updatedState.unidadeAtendimento = formData.unidadeAtendimento ? true : false;
      updatedState.tipoFiliacao = formData.tipoFiliacao ? true : false;

      updatedState.compositor = validaCompositor;
      updatedState.interprete = validaInterprete;
      updatedState.musico = validaMusico;
      updatedState.produtor = validaProdutor;

      updatedState.territorioConexao = validaTerritorioConexao;
      updatedState.territorioAutoral = validaTerritorioAutoral;
      updatedState.territorioConexaoOutros = validaterritorioConexaoOutros;
      updatedState.territorioAutoralOutros = validaTerritorioAutoralOutros;

      return updatedState;
    });
  }

  const handleChange = (event) => {
    let { name, value, type, checked } = event.target;

    value = limiteTamanhoCampos(name, value);

    const checksConexaoQuant = (formData.produtorFonograficoConexao ? 1 : 0) + (formData.interpreteConexao ? 1 : 0) + (formData.musicoConexao ? 1 : 0);

    setFormData((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: type === 'checkbox' ? checked : value,
      };

      if (name === 'compositorAutorAutorais' && !checked) {
        updatedState.territorioAdmAutorais = '';
        updatedState.territorioAdmAutoraisOutro = '';
      }

      if ((name === 'produtorFonograficoConexao' || name === 'interpreteConexao' || name === 'musicoConexao') && !checked && checksConexaoQuant <= 1) {
        updatedState.territorioAdmConexao = '';
        updatedState.territorioAdmConexaoOutro = '';
      }

      if (name === 'territorioAdmAutorais' && value != "Outros") {
        updatedState.territorioAdmAutoraisOutro = '';
      }

      if (name === 'territorioAdmConexao' && value != "Outros") {
        updatedState.territorioAdmConexaoOutro = '';
      }

      if (name === 'compositorAutorAutorais' && !checked) {
        updatedState.compositorAutorNaoFiliacao = false;
        updatedState.compositorAutorFiliado = false;
        updatedState.sociedadeCompositorAutor = '';
      }

      if (name === 'interpreteConexao' && !checked) {
        updatedState.interpreteNaoFiliacao = false;
        updatedState.InterpreteFiliado = false;
        updatedState.sociedadeInterprete = '';
      }

      if (name === 'musicoConexao' && !checked) {
        updatedState.musicoNaoFiliacao = false;
        updatedState.musicoFiliado = false;
        updatedState.sociedadeMusico = '';
      }

      if (name === 'produtorFonograficoConexao' && !checked) {
        updatedState.produtorFonograficoNaoFiliacao = false;
        updatedState.produtorFonograficoFiliado = false;
        updatedState.sociedadeProdutor = '';
      }

      if (name === 'produtorFonograficoConexao' && !checked) {
        updatedState.produtorFonograficoNaoFiliacao = false;
        updatedState.produtorFonograficoFiliado = false;
        updatedState.sociedadeProdutor = '';
      }

      if (name === 'compositorAutorFiliado' && !checked)
        updatedState.sociedadeCompositorAutor = '';

      if (name === 'InterpreteFiliado' && !checked)
        updatedState.sociedadeInterprete = '';

      if (name === 'musicoFiliado' && !checked)
        updatedState.sociedadeMusico = '';

      if (name === 'produtorFonograficoFiliado' && !checked)
        updatedState.sociedadeProdutor = '';

      if (name === 'territorioAdmAutorais' && value != 'Outros')
        updatedState.territorioAdmAutoraisOutro = '';

      if (name === 'territorioAdmConexao' && value != 'Outros')
        updatedState.territorioAdmConexaoOutro = '';

      return updatedState;
    });
  };

  useImperativeHandle(ref, () => ({
    validarFormulario() {
      if (Object.values(validacao).some(value => !value)) {
        return false;
      }
      return true;
    },
    getDados() {
      return formData;
    }
  }));

  const cssQuebraPagina = { 'page-break-after': 'auto', 'break-after': 'page', 'width': '100%', 'position': 'relative' };

  return (

    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Grid container maxWidth="md" spacing={2}>
        <Typography variant="h5" gutterBottom strong>
          Natureza da filiação
        </Typography>
      </Grid>
      <form>
        <Grid container spacing={2} sx={{ display: "flex", flexWrap: "wrap", marginTop: '10px' }}>
          <Grid container maxWidth="md" spacing={2}>
            <Grid item xs={12} sm={6} >
              <Typography variant="body2">
                Titular de direitos autorais
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.compositorAutorAutorais}
                    onChange={handleChange}
                    name="compositorAutorAutorais"
                  />
                }
                label={<span style={{ color: !validacao.naturezaFiliacao ? '#d32f2f' : '' }}>Compositor/Autor</span>}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" margin="normal" disabled={!formData.compositorAutorAutorais}
                error={formData.compositorAutorAutorais && !formData.territorioAdmAutorais}>
                <InputLabel>Território de Administração</InputLabel>
                <Select
                  name="territorioAdmAutorais"
                  value={formData.territorioAdmAutorais}
                  onChange={handleChange}
                  label="Território de Administração"
                >
                  <MenuItem value="2136">Mundo</MenuItem>
                  <MenuItem value="76">Brasil</MenuItem>
                  <MenuItem value="Outros">Outros</MenuItem>
                </Select>
              </FormControl>
              {(formData.territorioAdmAutorais === "Outros" && formData.compositorAutorAutorais) && (
                <TextField
                  fullWidth
                  label="Descreva o Território"
                  variant="outlined"
                  margin="normal"
                  name="territorioAdmAutoraisOutro"
                  value={formData.territorioAdmAutoraisOutro}
                  onChange={handleChange}
                  error={!formData.territorioAdmAutoraisOutro}
                />
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid>
                <Typography variant="body2">
                  Titular de direitos conexo
                </Typography>
                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.interpreteConexao}
                        onChange={handleChange}
                        name="interpreteConexao"
                      />
                    }
                    label={<span style={{ color: !validacao.naturezaFiliacao ? '#d32f2f' : '' }}>Intérprete</span>}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.musicoConexao}
                        onChange={handleChange}
                        name="musicoConexao"
                      />
                    }
                    label={<span style={{ color: !validacao.naturezaFiliacao ? '#d32f2f' : '' }}>Músico</span>}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.produtorFonograficoConexao}
                        onChange={handleChange}
                        name="produtorFonograficoConexao"
                      />
                    }
                    label={<span style={{ color: !validacao.naturezaFiliacao ? '#d32f2f' : '' }}>Produtor Fonográfico</span>}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" margin="normal"
                disabled={!(formData.produtorFonograficoConexao || formData.interpreteConexao || formData.musicoConexao)}
                error={(formData.produtorFonograficoConexao || formData.interpreteConexao || formData.musicoConexao) && !formData.territorioAdmConexao}>
                <InputLabel>Território de Administração</InputLabel>
                <Select
                  name="territorioAdmConexao"
                  value={formData.territorioAdmConexao}
                  onChange={handleChange}
                  label="Território de Administração"
                >
                  <MenuItem value="2136">Mundo</MenuItem>
                  <MenuItem value="76">Brasil</MenuItem>
                  <MenuItem value="Outros">Outros</MenuItem>
                </Select>
              </FormControl>
              {(formData.territorioAdmConexao === "Outros" && (formData.produtorFonograficoConexao || formData.interpreteConexao || formData.musicoConexao)) && (
                <TextField
                  fullWidth
                  label="Descreva o Território"
                  variant="outlined"
                  margin="normal"
                  name="territorioAdmConexaoOutro"
                  value={formData.territorioAdmConexaoOutro}
                  onChange={handleChange}
                  error={!formData.territorioAdmConexaoOutro}
                />
              )}
            </Grid>
          </Grid>

          <Grid container maxWidth="md" spacing={2}>
            {(!props.finalizado || !naoFiliadoVazio) &&
              <>
                <Grid item xs={12} mt={2}>
                  <Typography>
                    <strong>Declaração:</strong> <br />
                    Declaro que não sou filiado a nenhuma outra sociedade de direito autoral de
                    execução pública nas categorias assinaladas abaixo, sendo a UBC a primeira sociedade a qual me filio.
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.compositorAutorNaoFiliacao}
                          onChange={handleChange}
                          name="compositorAutorNaoFiliacao"
                        />
                      }
                      label={<span style={{ color: !validacao.compositor ? '#d32f2f' : '' }}>Compositor/Autor</span>}
                      disabled={!formData.compositorAutorAutorais || formData.compositorAutorFiliado}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.interpreteNaoFiliacao}
                          onChange={handleChange}
                          name="interpreteNaoFiliacao"
                        />
                      }
                      label={<span style={{ color: !validacao.interprete ? '#d32f2f' : '' }}>Intérprete</span>}
                      disabled={!formData.interpreteConexao || formData.InterpreteFiliado}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.musicoNaoFiliacao}
                          onChange={handleChange}
                          name="musicoNaoFiliacao"
                        />
                      }
                      label={<span style={{ color: !validacao.musico ? '#d32f2f' : '' }}>Músico</span>}
                      disabled={!formData.musicoConexao || formData.musicoFiliado}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.produtorFonograficoNaoFiliacao}
                          onChange={handleChange}
                          name="produtorFonograficoNaoFiliacao"
                        />
                      }
                      label={<span style={{ color: !validacao.produtor ? '#d32f2f' : '' }}>Produtor Fonográfico</span>}
                      disabled={!formData.produtorFonograficoConexao || formData.produtorFonograficoFiliado}
                    />
                  </FormControl>
                </Grid>
              </>
            }
          </Grid>

          {/* <div style={(!naoFiliadoVazio && !filiadoVazio) ? cssQuebraPagina : {}}></div> */}

          {((!naoFiliadoVazio && !filiadoVazio) && props.finalizado == true) && <Grid item xs={12}>
            <div style={cssQuebraPagina}></div>

            <Box sx={{ position: 'relative', height: '10px' }}>
              <img src="logo.png" alt="Minha Logo" style={{ position: 'absolute', top: 10, right: -50, height: '30px' }} />
            </Box>
          </Grid>}


          <Grid container maxWidth="md" spacing={2}>
            {(!props.finalizado || !filiadoVazio) &&
              <>
                {/* Declaração */}
                <Grid item xs={12} mt={2}>
                  <Typography>
                    <strong>Declaração:</strong> <br />
                    Declaro que sou filiado a outra sociedade de direito autoral de
                    execução pública nas categorias assinaladas abaixo, estou de acordo
                    a me desligar dessa outra filiação.
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.compositorAutorFiliado}
                          onChange={handleChange}
                          name="compositorAutorFiliado"
                        />
                      }
                      label={<span style={{ color: !validacao.compositor ? '#d32f2f' : '' }}>Compositor/Autor</span>}
                      disabled={!formData.compositorAutorAutorais || formData.compositorAutorNaoFiliacao}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.InterpreteFiliado}
                          onChange={handleChange}
                          name="InterpreteFiliado"
                        />
                      }
                      label={<span style={{ color: !validacao.interprete ? '#d32f2f' : '' }}>Intérprete</span>}
                      disabled={!formData.interpreteConexao || formData.interpreteNaoFiliacao}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.musicoFiliado}
                          onChange={handleChange}
                          name="musicoFiliado"
                        />
                      }
                      label={<span style={{ color: !validacao.musico ? '#d32f2f' : '' }}>Músico</span>}
                      disabled={!formData.musicoConexao || formData.musicoNaoFiliacao}
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.produtorFonograficoFiliado}
                          onChange={handleChange}
                          name="produtorFonograficoFiliado"
                        />
                      }
                      label={<span style={{ color: !validacao.produtor ? '#d32f2f' : '' }}>Produtor Fonográfico</span>}
                      disabled={!formData.produtorFonograficoConexao || formData.produtorFonograficoNaoFiliacao}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>

                  <Grid>
                    <FormControl fullWidth variant="outlined" margin="normal" disabled={!formData.compositorAutorFiliado} error={!validacao.sociedadeCompositorAutor}>
                      <InputLabel>Sociedade como Compositor/Autor</InputLabel>
                      <Select
                        name="sociedadeCompositorAutor"
                        value={formData.sociedadeCompositorAutor}
                        onChange={handleChange}
                        label="Sociedade como Compositor/Auto"
                      >
                        {sociedades.sort().map((item) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl fullWidth variant="outlined" margin="normal" disabled={!formData.InterpreteFiliado} error={!validacao.sociedadeInterprete}>
                      <InputLabel>Sociedade como interprete</InputLabel>
                      <Select
                        name="sociedadeInterprete"
                        value={formData.sociedadeInterprete}
                        onChange={handleChange}
                        label="Sociedade como interprete"
                      >
                        {sociedades.map((item) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl fullWidth variant="outlined" margin="normal" disabled={!formData.musicoFiliado} error={!validacao.sociedadeMusico}>
                      <InputLabel>Sociedade como Músico</InputLabel>
                      <Select
                        name="sociedadeMusico"
                        value={formData.sociedadeMusico}
                        onChange={handleChange}
                        label="Sociedade como Músico"
                      >
                        {sociedades.map((item, index) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl fullWidth variant="outlined" margin="normal" disabled={!formData.produtorFonograficoFiliado} error={!validacao.sociedadeProdutor}>
                      <InputLabel>Sociedade como Produtor</InputLabel>
                      <Select
                        name="sociedadeProdutor"
                        value={formData.sociedadeProdutor}
                        onChange={handleChange}
                        label="Sociedade como Produtor"
                      >
                        {sociedades.map((item, index) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                  </Grid>
                </Grid>
              </>
            }

          </Grid>

          {(!(!naoFiliadoVazio && !filiadoVazio) && props.finalizado == true) && <Grid item xs={12}>
            <div style={cssQuebraPagina}></div>

            <Box sx={{ position: 'relative', height: '10px' }}>
              <img src="logo.png" alt="Minha Logo" style={{ position: 'absolute', top: 10, right: -50, height: '30px' }} />
            </Box>
          </Grid>}

          <Grid item xs={12}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <FormControl component="fieldset" margin="normal" required
                error={!validacao.tipoFiliacao}>
                <FormLabel component="legend">Tipo de Filiação</FormLabel>
                <RadioGroup
                  name="tipoFiliacao"
                  value={formData.tipoFiliacao}
                  onChange={handleChange}
                  row
                >
                  <FormControlLabel value="nacional" control={<Radio />} label="Nacional" />
                  <FormControlLabel value="estrangeiro" control={<Radio />} label="Estrangeiro" />
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>

            {!(props.finalizado || formData?.impressao) &&
              <FormControl fullWidth variant="outlined" margin="normal"
                required
                error={!validacao.unidadeAtendimento}>
                <InputLabel>Unidade de Atendimento</InputLabel>
                <Select
                  name="unidadeAtendimento"
                  value={formData?.unidadeAtendimento}
                  onChange={handleChange}
                  label="Unidade de Atendimento"
                >
                  {unidadesAtendimento.map((item) => (
                    <MenuItem key={item.id} value={item}>
                      {item.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            }
            {(props.finalizado || formData?.impressao) &&
              <TextField
                fullWidth
                label="Unidade de Atendimento"
                variant="outlined"
                margin="normal"
                name="contatoAtendimento"
                value={formData.unidadeAtendimento.nome}
              />
            }

          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Contato do Atendimento"
              variant="outlined"
              margin="normal"
              name="contatoAtendimento"
              value={formData.contatoAtendimento}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined" margin="normal">
              <InputLabel>Como conheceu a UBC?</InputLabel>
              <Select
                name="comoConheceuUBC"
                value={formData?.comoConheceuUBC}
                onChange={handleChange}
                label="Como conheceu a UBC?"
              >
                {listaComoConheceuUBC.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Quem te indicou para UBC?"
              variant="outlined"
              margin="normal"
              name="quemIndicouUBC"
              value={formData.quemIndicouUBC}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box mt={2}>
          <Typography variant="body2" color="textSecondary">
            Campos marcados com * são obrigatórios.
          </Typography>
        </Box>

      </form>
    </Box>
  );
});

export default FormularioFiliacaoUBC;
